import './brand.css'
import './app.css'
import { login } from './auth'
import './components/meat-room'

class MeatApp extends HTMLElement {
  constructor() {
    super()

    window.addEventListener('hashchange', () => this.handleRoute())
  }

  connectedCallback() {
    this.handleRoute()
  }

  handleRoute() {
    const path = window.location.hash.slice(1)
    if (path.startsWith('/rooms')) {
      const parts = path.split("/").filter(p => p != '')
      if (parts.length == 1) {
        // No slug yet: start a new room. Replacing keeps the bare #/rooms out of
        // history, and the hashchange brings us back here to render it.
        location.replace(`#/rooms/${crypto.randomUUID().slice(0, 8)}`)
      } else {
        const roomSlug = parts[1]!
        const room = document.createElement('meat-room')
        room.setAttribute('slug', roomSlug)
        this.replaceChildren(room)
      }
    }
  }
}

// Nothing renders until the user has logged in: <meat-app> stays an inert,
// empty element until it's defined.
await login()
customElements.define('meat-app', MeatApp)
